import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import centerServices from "../../services/center.services";
import xrayBookingsServices from "../../services/xrayBookings.services";
import BookingList from "../../components/XrayBookings/XrayBookingsList";
import XrayBookingForm from "../../components/XrayBookings/XrayBookingForm";
import TransactionList from "../../components/Transactions/TransactionList";
import ExportExcel from "../../components/ExportExcel";
import { formattedDate } from "../../helpers/Helper";
const Transactions = () => {

  const [transactionList, setTransactionList] = useState([])
  const [loading, setLoading] = useState(true);

  const getAllTransactions = async () => {
    const transaction = await xrayBookingsServices.tansactionList();
    if (transaction.status === 200) {
      setTransactionList(transaction.data.transactionList);
    }
    setLoading(false);
  };
  useEffect(() => {
    getAllTransactions();
  }, []);

  const filterExcelData = transactionList.map((item, index) => {
    const obj = {
      "Sr.No.": index + 1,
      "Booking Id": item.xray_booking_id,
      "Payment Mode": item.payment_mode,
      "Transaction Id": item.transaction_id,
      "Transaction Date": formattedDate(item.transaction_date),
      "amount": item.amount
    }
    return obj
  })
  return (
    <React.Fragment>
      {/*page-wrapper*/}
      <div className="page-wrapper">
        {/*page-content-wrapper*/}
        <div className="page-content-wrapper">
          <div className="page-content">
            <>
              {/*breadcrumb*/}
              <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                {/* <div className="breadcrumb-title pe-3">Center</div> */}
                <div className="ps-3">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0 p-0">
                      <li className="breadcrumb-item">
                        <a href="#">
                          {/* <i className="bx bx-home-alt" /> */}
                        </a>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        X-ray Bookings Transactions
                      </li>
                    </ol>
                  </nav>
                </div>
                <div className="ms-auto">
                  <div className="btn-group">
                    {/* <button className="btn btn-primary"
                                            onClick={() =>{
                                                toggle();
                                                setIsAddMode('Add')
                                                }}><i className="bx bx plus" />Add</button> */}
                    <ExportExcel excelData={filterExcelData} fileName={"transactionList"} />

                  </div>
                </div>
              </div>
              {/*end breadcrumb*/}
              <div className="card">

                <div className="card-body">

                  <TransactionList
                    data={transactionList}
                    loading={loading}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Transactions;
